import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { AGGREGATE, SOURCES } from "@/data/reviews";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LiveStatsContext = createContext(null);

// Initial fallback = the static aggregate counts baked in at build time.
const fallback = {
  rating: AGGREGATE.rating,
  total: AGGREGATE.count,
  googleCount: SOURCES.Google.totalReviews,
  hitchedCount: SOURCES.Hitched.totalReviews,
  facebookCount: SOURCES.Facebook.totalReviews,
  bridebookCount: SOURCES.Bridebook.totalReviews,
  guidesForBridesCount: SOURCES.GuidesForBrides.totalReviews,
  isLive: false,
};

export function LiveStatsProvider({ children }) {
  const [stats, setStats] = useState(fallback);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/google-reviews`)
      .then((res) => {
        if (cancelled) return;
        const liveGoogle =
          typeof res.data?.userRatingCount === "number"
            ? res.data.userRatingCount
            : fallback.googleCount;
        const liveRating =
          typeof res.data?.rating === "number" ? res.data.rating : fallback.rating;
        setStats({
          rating: liveRating || fallback.rating,
          total:
            fallback.hitchedCount +
            liveGoogle +
            fallback.facebookCount +
            fallback.bridebookCount +
            fallback.guidesForBridesCount,
          googleCount: liveGoogle,
          hitchedCount: fallback.hitchedCount,
          facebookCount: fallback.facebookCount,
          bridebookCount: fallback.bridebookCount,
          guidesForBridesCount: fallback.guidesForBridesCount,
          isLive: true,
        });
      })
      .catch(() => {
        /* keep fallback */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <LiveStatsContext.Provider value={stats}>{children}</LiveStatsContext.Provider>
  );
}

export function useLiveStats() {
  return useContext(LiveStatsContext) || fallback;
}
